import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SettingLayout from "./Components/SettingLayout";
import DeleteModal from "../../components/Modal/DeleteModal";
import { Button, Flex, notification } from "antd";
import { Card } from "iconsax-react";
import PaymentMethodGrid from "./Components/PaymentMethodGrid";
import PaymentMethodItem from "./Components/PaymentMethodItem";
import PaymentMethodAddCard from "./Components/PaymentMethodAddCard";
import { mixPostV1 } from "../../services/mixin";
import "./PaymentMethodCustom.css";
import PaymentModal from "../../components/Modal/PaymentModal";
import SelectPaymentMethodModal from "../../components/Modal/SelectPaymentMethodModal";

// CHECK ROLE = 'USER'
const user = JSON.parse(localStorage.getItem("user") || "{}");
const store_id = localStorage.getItem("storeId") || "";
const permission = user.permission;
const settingRole = permission
  ? permission.find((item: any) => item.function_id === 7)
  : null;
let waitx = false;

const SettingPaymentMethod: React.FC = () => {
  const navigate = useNavigate();
  const [showAddCard, setShowAddCard] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [items, setItems] = useState([] as any[]);
  const [history, setHistory] = useState<any[]>([]);
  const [plan, setPlan] = useState<any>(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showSelectPaymentMethod, setShowSelectPaymentMethod] = useState(false);
  const [comboCards, setComboCards] = useState<any[]>([]);
  const [publishKey, setpublishKey] = useState<string>("");
  const gKeyStripe = async () => {
    const res = await mixPostV1("/api/webAdmin/gKeyStripe.php", {});
    waitx = false;

    if (res.status === 1) {
      setpublishKey(res.data.public_key);
    }
  };
  const getItems = async () => {
    if (waitx) return;
    waitx = true;
    const res = await mixPostV1("/api/webAdmin/gListPaymentCard.php", {});
    waitx = false;
    if (res.status === 1 && res.data) {
      setHistory(res.data.historyPayment || []);
      setPlan(res.data.infoPlanStore || null);
      setItems(
        (res.data.listPayment || []).map((val: any) => ({
          ...val,
          id: val.card_id,
          name: val.card_name,
          number: `**** **** **** ${val.last_number}`,
          isDefault: val.is_default === 1,
          image:
            val.brand === "VISA"
              ? "/images/banks/visa.svg"
              : "/images/banks/mastercard.svg",
        })),
      );
    }
  };
  useEffect(() => {
    gKeyStripe();
    getItems();
  }, []);

  let waitx2 = false;
  const setDefault = async (id: any) => {
    if (waitx2 === true) {
      return;
    }
    waitx2 = true;
    const params = {
      card_id: id,
    } as any;
    const res = await mixPostV1(
      "/api/webAdmin/setDefaultPaymentCard.php",
      params,
    );
    if (res.status === 1) {
      waitx2 = false;
      openNotification("success");
      getItems();
    } else {
      waitx2 = false;
      openNotification("error", res.message);
    }
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Card added!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // Hàm lấy danh sách thẻ từ API mới
  const getComboCards = async () => {
    const res = await mixPostV1("/api/webAdmin/gComboCardByStore.php", {});
    if (res.status === 1 && res.data) {
      return (res.data || []).map((val: any) => ({
        key: val.card_id.toString(),
        label: `${val.brand} ****${val.last_number} ${val.card_name}`.trim(),
        icon: (
          <img
            src={
              val.brand === "VISA"
                ? "/images/banks/visa.svg"
                : "/images/banks/mastercard.svg"
            }
            alt=""
            style={{ width: 32 }}
          />
        ),
      }));
    }
    return [];
  };

  return (
    <>
      {contextHolder}
      {/* Payment Modal */}
      <PaymentModal
        isShow={showPaymentModal}
        storeId={store_id}
        onModalClose={() => setShowPaymentModal(false)}
        onModalSubmit={() => {
          setShowPaymentModal(false);
          getItems();
        }}
      />
      <SelectPaymentMethodModal
        isShow={showSelectPaymentMethod}
        publishKey={publishKey}
        amount={plan?.income || 1000}
        planName={plan?.plan_name || "Full service"}
        paymentMethods={[
          ...comboCards,
          {
            key: "card",
            label: "Card",
            icon: (
              <img
                src="/images/banks/mastercard.svg"
                alt=""
                style={{ width: 32 }}
              />
            ),
          },
        ]}
        onCancel={() => setShowSelectPaymentMethod(false)}
        onSelectCard={() => {
          setShowSelectPaymentMethod(false);
          setShowPaymentModal(true);
        }}
        onPaymentSuccess={() => {
          getItems();
        }}
      />
      <SettingLayout current="payment-method">
        <div className="setting-content setting-payment-method">
          <div className="mw-687">
            <Flex gap={32} align="start" className="payment-method-main-flex">
              <div style={{ flex: 2 }}>
                {/* Order history */}
                <div className="order-history-block">
                  <div className="order-history-title">Order history</div>
                  <table className="order-history-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Payment method</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.date_payment}</td>
                          <td>{item.amount}</td>
                          <td>{item.pay_method}</td>
                          <td
                            style={{
                              color:
                                item.status_pay === 0 || item.is_refund === 1
                                  ? "#FD8181"
                                  : "#55c790",
                            }}
                          >
                            {item.is_refund === 1
                              ? "Refund"
                              : item.status_pay === 0
                                ? "Fail"
                                : "Success"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* ADD CARD */}
                <PaymentMethodAddCard
                  isShow={showAddCard}
                  onPopupClose={() => setShowAddCard(false)}
                  onSuccess={() => {
                    setShowAddCard(false);
                    getItems();
                  }}
                />
                {/* REMOVE CARD */}
                <DeleteModal
                  isShow={showDeletePopup}
                  content="Are you sure you want to delete this card?"
                  message="Card removed!"
                  yesText="Yes, Delete permanently"
                  deleteApi="/api/webAdmin/deleteCardPayment.php"
                  deleteId={selectedId}
                  deleteKey="card_id"
                  onModalClose={() => setShowDeletePopup(false)}
                  onModalSubmit={() => {
                    getItems();
                    setShowDeletePopup(false);
                  }}
                />
              </div>
              {/* Plan info */}
              <div style={{ flex: 1 }}>
                {plan && (
                  <>
                    <div className="plan-info-block">
                      <div className="plan-title">Your plan</div>
                      <div className="plan-name">
                        {plan.plan_name || "Full service"}
                      </div>
                      <div className="plan-price">
                        {plan.income
                          ? `${plan.income}$/${plan?.duration ?? ""} month`
                          : "1000$/month"}
                      </div>
                      {plan.is_expired === 1 ? (
                        <div className="plan-expired" style={{ color: "red" }}>
                          {plan.status_name}
                        </div>
                      ) : (
                        <div className="plan-expired">
                          Renew on {plan.date_expired}
                        </div>
                      )}
                    </div>
                    {plan.is_expired === 1 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 16,
                        }}
                      >
                        <Button
                          className="button-yellow"
                          onClick={async () => {
                            const cards = await getComboCards();
                            setComboCards(cards);
                            setShowSelectPaymentMethod(true);
                          }}
                        >
                          Payment
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Flex>
            {/* Payment Method */}
            <div className="payment-method-block">
              <Flex
                gap={12}
                align="center"
                justify="space-between"
                style={{ marginBottom: 16 }}
              >
                <div className="payment-method-title">Payment Method</div>
                <Button
                  icon={<Card size={20} variant="Bulk" />}
                  className="rs-button button-update"
                  disabled={settingRole && settingRole.is_create === 0}
                  onClick={() => setShowAddCard(true)}
                >
                  Add
                </Button>
              </Flex>
              <PaymentMethodGrid>
                {items.length > 0 &&
                  items.map((item: any) => (
                    <PaymentMethodItem
                      key={item.id}
                      cardName={item.name}
                      cardNumber={item.number}
                      cardLogo={item.image}
                      isDefault={item.isDefault}
                      editDisabled={settingRole && settingRole.is_edit === 0}
                      deleteDisabled={
                        settingRole && settingRole.is_delete === 0
                      }
                      onRemove={() => {
                        setShowDeletePopup(true);
                        setSelectedId(item.id);
                      }}
                      onSetDefault={() => setDefault(item.id)}
                    />
                  ))}
              </PaymentMethodGrid>
            </div>
          </div>
        </div>
      </SettingLayout>
    </>
  );
};

export default SettingPaymentMethod;
